import { Token } from '@stitches/react/types/theme'

import { theme } from './stitches.config'

export const shared = {
  buttonReset: {
    all: 'unset',
    cursor: 'pointer',
    boxSizing: 'border-box',
    border: 'none',
    backgroundColor: 'transparent',
    margin: 0,
    padding: 0,
  },
  scrollBars: ({
    backgroundColor = 'transparent',
    handleColor = theme.colors.bg2.computedValue,
    hoverColor = theme.colors.bg3.computedValue,
  }: {
    backgroundColor?: Token['computedValue'] | 'transparent'
    handleColor?: Token['computedValue']
    hoverColor?: Token['computedValue']
  }) => {
    return {
      // FF
      scrollbarWidth: `thin`,
      scrollbarColor: `${handleColor} ${backgroundColor}`,

      // Chrome, Edge, and Safari
      '&::-webkit-scrollbar': {
        width: 4,
        height: 4,
      },
      '&::-webkit-scrollbar-track': {
        background: backgroundColor,
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: handleColor,
        borderRadius: 4,

        '&:hover': {
          backgroundColor: hoverColor,
        },
      },
    }
  },
}
